module.exports = {"id":"200588","name":"Hong Jeong Ho","rating":"72","photo":"./data/images/photos/4/200588.png","club":{"name":"Jeonbuk Hyundai","logo":"./data/images/clubs/JeonbukHyundai.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HongJeongHo0.json
// module id = 1749
// module chunks = 0